
































import { Vue, Component, Prop } from 'vue-property-decorator';
import PerformanceItem from '../PerformanceItem/PerformanceItem.vue';

@Component({
  components: { PerformanceItem }
})
export default class PerformanceList extends Vue {
  @Prop() totalValues!: Record<string, any>;

  observer: IntersectionObserver | null = null;
  triggerIntersected = false;

  get transformedTotalValues() {
    const result = Object.entries(this.totalValues).map(([key, value]) => ({
      ...value,
      slug: key
    }));

    return result;
  }

  handleTriggerObserver() {
    if (!this.$mobileCheck()) return;

    const target = document.querySelector(
      '.performance-overview__grid-trigger'
    );

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.triggerIntersected = entry.isIntersecting;
      },
      {
        root: document.querySelector('.performance-overview__grid'),
        threshold: 0
      }
    );

    this.observer.observe(target as HTMLElement);
  }

  mounted() {
    this.handleTriggerObserver();
  }

  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  }
}
